import { Component } from "@angular/core";
import { SvgIcon } from "@ponder-shared/utils/svgIcons";
import { SidebarButtonLinkComponent } from "./sidebar-button-link.component";

@Component({
    selector: "sidebar-news",
    imports: [],
    templateUrl: "./sidebar-button-link.component.html"
})
export class SidebarNewsButtonComponent extends SidebarButtonLinkComponent {
    public constructor() { super("News", SvgIcon.News, "/news", false); }
}